import { Injectable, OnDestroy, Provider, Type } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { Subject, Subscription } from 'rxjs';

declare module '@angular/core' {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}

/** @ignore */
@Injectable({
  providedIn: 'root',
})
export class IdleService implements OnDestroy {
  timeout$: Subject<any>;
  timeoutSub: Subscription;
  timerStart$: Subject<any>;
  timerStartSub: Subscription;

  constructor(private userIdle: UserIdleService) {
    this.timeout$ = new Subject();
    this.timerStart$ = new Subject();
  }

  ngOnDestroy(): void {
    this.timerStartSub.unsubscribe();
    this.timeoutSub.unsubscribe();
  }

  startIdleTimer() {
    this.userIdle.startWatching();
    this.sub();
  }

  stopIdleTimer() {
    this.userIdle.stopTimer();
    this.userIdle.stopWatching();
    this.unsub();
  }

  resetTimer() {
    this.userIdle.resetTimer();
  }

  private sub() {
    this.timeoutSub = this.userIdle.onTimeout().subscribe(() => {
      this.timeout$.next();
    });

    this.timerStartSub = this.userIdle.onTimerStart().subscribe((count) => {
      this.timerStart$.next(count);
    });
  }

  private unsub() {
    if (!this.timeoutSub) {
      return;
    }

    this.timeoutSub.unsubscribe();
    this.timerStartSub.unsubscribe();
  }
}
